export const DEFAULT_LOWERCASE_LETTERS = "abcdefghijklmnopqrstuvwxyz";
export const DEFAULT_UPPERCASE_LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const DEFAULT_NUMBERS = "0123456789";
export const DEFAULT_SPECIAL_CHARACTERS = "!@#$%^&*()_+-=`~[]\\{}|;':\",./<>?";
